import { useIntl } from 'react-intl';

import BarrierActionModalForm from 'src/features/parkingActions/components/BarrierActionModalForm';
import { type Action } from 'src/features/parkingActions/routes/AllActions';
import { GeneralBlockHead, GeneralBlockTitle, GeneralBlockSubtitle } from 'src/registry/components/blocks/GeneralBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';

interface Props extends Omit<React.ComponentProps<typeof Button>, 'title'> {
    action: Action;
}

export default function ActionBox({ action, ...buttonProps }: Props) {
    const { formatMessage } = useIntl();
    return (
        <BarrierActionModalForm
            triggerComponent={
                <Button
                    variant="outline"
                    className="h-auto justify-start gap-4 rounded-xl p-4 text-left font-normal"
                    {...buttonProps}
                >
                    <SquareIcon
                        icon={action.icon}
                        variant={buttonProps.variant === 'destructiveLight' ? 'destructiveLight' : undefined}
                    />
                    <GeneralBlockHead className="min-w-64">
                        <GeneralBlockTitle className="max-w-full text-sm break-words whitespace-normal text-gray-900 sm:text-base">
                            {formatMessage(action.title)}
                        </GeneralBlockTitle>
                        <GeneralBlockSubtitle className="max-w-full text-sm break-words whitespace-normal sm:text-base">
                            {formatMessage(action.subtitle)}
                        </GeneralBlockSubtitle>
                    </GeneralBlockHead>
                </Button>
            }
            action={action}
            variant={buttonProps.variant}
        />
    );
}
